import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "../../axios/axios";

export const techTextLedger = createAsyncThunk(
  "communication/tech/textLedger",
  async ({ template, customer, techID, templateType, recipientNumber }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post(
        "/comm/portal/tech-texts-ledger",
        {
          template,
          customer,
          techID,
          templateType,
          recipientNumber,
        },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
